const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate numberFormatterBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const numberValue = await evaluateSource(source.number, content, parentContentPath, transientContext, nativeFunctions);
  if (numberValue === undefined || Number.isNaN(Number(numberValue))) {
    return undefined;
  }
  const minimumIntegerDigits = (await evaluateSource(source.minimumIntegerDigits, content, parentContentPath, transientContext, nativeFunctions)) || 1;
  const minimumFractionDigits = (await evaluateSource(source.minimumFractionDigits, content, parentContentPath, transientContext, nativeFunctions)) || 0;
  const maximumFractionDigits = (await evaluateSource(source.maximumFractionDigits, content, parentContentPath, transientContext, nativeFunctions)) || 2;
  const options = {
    minimumIntegerDigits,
    minimumFractionDigits,
    maximumFractionDigits,
    style: 'decimal',
    useGrouping: false
  };
  return new Intl.NumberFormat([], options).format(numberValue);
};
module.exports = {
  evaluate
};